import {
  HoverScoreChip,
  ScoreChip,
  useScoreContext,
} from "@circle-react-shared/ActivityScore";
import { Typography } from "@circle-react-uikit/Typography";
import { useShouldShowCommunityAiModal } from "@circle-react/hooks/useIsActivityScoreEnabled";

import { t } from "@/i18n-js/instance";

import { getDisabledScoreDetail } from "./utils";

export function ScoreCell({
  memberId,
  className,
  shortDisabledLabel = false,
  shouldHideIfNoScore = false,
}: {
  memberId: number;
  className?: string;
  shortDisabledLabel?: boolean;
  shouldHideIfNoScore?: boolean;
}) {
  const { data, isInitialLoading: isLoading } = useScoreContext();
  const shouldShowCommunityAiModal = useShouldShowCommunityAiModal();

  if (isLoading) {
    return null;
  }

  if (shouldShowCommunityAiModal) {
    const disabledScoreDetail = getDisabledScoreDetail(shortDisabledLabel);

    return (
      <ScoreChip
        activityScore={disabledScoreDetail.activityScore}
        className={className}
      />
    );
  }

  const scoreDetail = data?.get(memberId);

  if (shouldHideIfNoScore && !scoreDetail) {
    return null;
  }

  if (!scoreDetail) {
    return (
      <Typography.LabelSm color="text-default">{t("n/a")}</Typography.LabelSm>
    );
  }

  return <HoverScoreChip scoreDetail={scoreDetail} className={className} />;
}
